import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Breadcrumb, Dropdown, Flex, Row, Space, Switch, Button } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import styles from "../styles/SettingEmailTemplateList.module.css";

const SettingEmailTemplateList = ({
    emailTemplateList = [],
    isLoading = false,
    pagination = {},
    onChange = () => { },
    onStatus = () => { },
    onDelete = () => { },
    onCreate = () => { },
    onEdit = () => { },
    embedded = false,
}) => {
    const { t, i18n } = useTranslation();
    const { roles } = useSelector((state) => state.company);

    const columns = [
        {
            title: <div className="text-table">{t("common.index")}</div>,
            dataIndex: "id",
            key: "id",
            width: "8%",
            align: "center",
            render: (text, record, index) => index + 1,
        },
        {
            title: <div className="text-table">{t("setting_email_template_list.label.template_name")}</div>,
            dataIndex: "templateName",
            key: "templateName",
            width: "16%",
        },
        {
            title: <div className="text-table">{t("setting_email_template_list.label.email_event")}</div>,
            dataIndex: "emailTemplateCode",
            key: "emailTemplateCode",
            width: "21%",
            render: (value) => value || t("setting_email_template_list.label.no_event_linked"),
        },
        {
            title: <div className="text-table">{t("setting_email_template_list.label.subject")}</div>,
            dataIndex: "subject",
            key: "subject",
            width: "24%",
        },
        {
            title: <div className="text-table">{t("account_category_list.label.last_modified")}</div>,
            dataIndex: "updateDate",
            key: "updateDate",
            width: "13%",
            render: (_, record) => {
                const { createBy, updateBy, createDate, updateDate } = record;
                const lastModified = updateBy || createBy;
                const name = lastModified
                    ? (i18n.language === "en" && lastModified.nameEn
                        ? lastModified.nameEn
                        : lastModified.name)
                    : null;
                return (
                    <>
                        {name}
                        {name && <br />}
                        {(createDate || updateDate)
                            ? dayjs(updateDate ?? createDate).format("DD/MM/YYYY HH:mm")
                            : "-"}
                    </>
                );
            },
        },
        {
            title: <div className="text-table">{t("year_accumulate_list.label.status")}</div>,
            dataIndex: "statusFlag",
            key: "statusFlag",
            align: "center",
            width: "10%",
            render: (text, record) => (
                <Switch
                    checked={text === "ACTIVE"}
                    onChange={(checked) => onStatus(checked, record)}
                // disabled={!roles.includes("UPDATE_MASTER_DATA_LIST|SETTING_EMAIL_TEMPLATE")}
                />
            ),
        },
        // (roles.includes("UPDATE_MASTER_DATA_LIST|SETTING_EMAIL_TEMPLATE") ||
        //     roles.includes("DELETE_MASTER_DATA_LIST|SETTING_EMAIL_TEMPLATE")) ? 
        {
            title: <div className="text-table">{t("action.action")}</div>,
            key: "action",
            width: "8%",
            align: "center",
            fixed: "right",
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            // items: [
                            //     roles.includes("UPDATE_MASTER_DATA_LIST|SETTING_EMAIL_TEMPLATE") && {
                            //         key: "1",
                            //         onClick: () => onEdit(record),
                            //         label: t("action.edit"),
                            //         icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
                            //     },
                            //     roles.includes("DELETE_MASTER_DATA_LIST|SETTING_EMAIL_TEMPLATE") &&
                            //     record?.statusFlag !== "ACTIVE" && {
                            //         key: "2",
                            //         onClick: () => onDelete(record),
                            //         label: t("action.delete"),
                            //         icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
                            //     },
                            // ],
                            items: [
                                {
                                    key: "1",
                                    onClick: () => onEdit(record),
                                    label: t("action.edit"),
                                    icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                                record?.statusFlag !== "ACTIVE" && {
                                    key: "2",
                                    onClick: () => onDelete(record),
                                    label: t("action.delete"),
                                    icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                            ].filter(Boolean),
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
        // : {},
    ];
    const content = (
        <Space className={styles.container} direction="vertical" size={24}>
            {!embedded && (
                <Flex vertical>
                    <Breadcrumb
                        items={[
                            { title: t("home.header"), href: "/" },
                            { title: t("masterdata.header"), href: "" },
                            { title: t("setting_email_template_list.header") },
                        ]}
                    />
                    <h2>{t("setting_email_template_list.header")}</h2>
                </Flex>
            )}
            <Row justify="end">
                <Space direction="horizontal" size={24}>
                    <Button
                        onClick={onCreate}
                        style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                        type="primary"
                    >
                        <Flex align="center" justify="center" gap={8}>
                            <CreateIcon />
                            <span>{t("setting_email_template_list.create")}</span>
                        </Flex>
                    </Button>
                </Space>
            </Row>
            <TableAntd
                columns={columns}
                dataSource={emailTemplateList}
                onDelete={onDelete}
                loading={isLoading}
                pagination={pagination}
                onChange={onChange}
            />
        </Space>
    );

    return embedded ? content : <MainLayout>{content}</MainLayout>;
};


export default SettingEmailTemplateList;